import { fireEvent, render, screen, waitFor } from '@testing-library/react';
import Recommendations from './Recommendations';
import { getReporting } from '../../api/reporting';
import { makeRecommendations } from './recommendationRules';

jest.mock('../../api/reporting', () => ({ getReporting: jest.fn() }));

const report = {
  role: 'hod',
  range: { from: '2026-09-01', to: '2026-09-21' },
  departments: [{ id: 'team', name: 'Team' }],
  people: [{ id: 'ada', name: 'Ada User', departmentIds: ['team'] }, { id: 'ben', name: 'Ben User', departmentIds: ['team'] }],
  employees: [{ id: 'ada', name: 'Ada User', expectedDays: 10, presentDays: 7, tasksAssigned: 10, tasksCompleted: 5 },
    { id: 'ben', name: 'Ben User', expectedDays: 10, presentDays: 9, tasksAssigned: 10, tasksCompleted: 8 }],
  metrics: { expectedDays: 20, presentDays: 16, tasksAssigned: 20, tasksCompleted: 13 },
};

beforeEach(() => { jest.clearAllMocks(); getReporting.mockResolvedValue(report); });

it('shows evidence-based team recommendations and fetches a selected person with the same reporting scope', async () => {
  render(<Recommendations active />);
  expect(await screen.findByText('Review attendance barriers')).toBeInTheDocument();
  expect(screen.getByText(/16\/20 expected days present/)).toBeInTheDocument();
  expect(screen.getByText('Offer individual attendance support')).toBeInTheDocument();
  fireEvent.change(screen.getByLabelText('Recommendation person'), { target: { value: 'ada' } });
  await waitFor(() => expect(getReporting).toHaveBeenLastCalledWith(expect.objectContaining({ section: 'overview', employeeId: 'ada' })));
  await waitFor(() => expect(screen.queryByRole('status')).not.toBeInTheDocument());
  fireEvent.click(screen.getByRole('button', { name: 'How can task delivery improve?' }));
  expect(screen.getByText('Review task capacity and blockers')).toBeInTheDocument();
});

it('limits staff UI to personal recommendations', async () => {
  getReporting.mockResolvedValue({ ...report, role: 'staff', people: [report.people[0]], employees: [report.employees[0]], metrics: { expectedDays: 10, presentDays: 7 } });
  render(<Recommendations active />);
  expect(await screen.findByText('Review attendance barriers')).toBeInTheDocument();
  expect(screen.queryByLabelText('Recommendation person')).not.toBeInTheDocument();
  expect(screen.queryByLabelText('Recommendation department')).not.toBeInTheDocument();
});

it('does not infer poor performance from missing task activity or approved leave', () => {
  const notes = makeRecommendations({ employees: [{ name: 'Ada' }], metrics: { leaveDays: 2, tasksAssigned: 0, expectedDays: 0 } });
  expect(notes.some((note) => note.title === 'Review task capacity and blockers')).toBe(false);
  expect(notes.some((note) => note.title === 'Review attendance barriers')).toBe(false);
  expect(notes.some((note) => note.title === 'Plan leave coverage')).toBe(true);
});
